import axios from 'axios'
import Toast from './toast'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://datihoutai.qinfenniao.com/prod-api',  // 后端API地址
  timeout: 10000
})

// 请求拦截器    https://dati.
// hkxs.com.cn/prod-api、
// http://localhost:1637
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回的code不是200，说明接口有问题
    if (res.code && res.code !== 200) {
      // 登录过期处理（401 或 返回"请先登录"）
      if (res.code === 401 || res.msg === '请先登录') {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        Toast.alert('登录已过期，请重新登录', () => {
          window.location.href = '/login'
        })
        return Promise.reject(new Error('登录已过期'))
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    // HTTP错误状态码处理
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      Toast.alert('登录已过期，请重新登录', () => {
        window.location.href = '/login'
      })
    }
    return Promise.reject(error)
  }
)

export default service
